import { PermissionData } from "@/definitions/types/permissions/permissions"
import { getPermissions } from "@/service/permissions"
import {
  keepPreviousData,
  useQuery,
} from "@tanstack/react-query"
import { AxiosError } from "axios"

const PERMISSIONS_CACHE_KEY = "permissions_cache"

const getPermissionsFromCache = (): PermissionData | undefined => {
  if (typeof window === "undefined") return undefined
  try {
    const cached = localStorage.getItem(PERMISSIONS_CACHE_KEY)
    return cached ? JSON.parse(cached) : undefined
  } catch {
    return undefined
  }
}

const savePermissionsToCache = (data: PermissionData) => {
  try {
    localStorage.setItem(PERMISSIONS_CACHE_KEY, JSON.stringify(data))
  } catch {
    // Silently fail if localStorage is full or unavailable
  }
}

export const clearPermissionsCache = () => {
  try {
    localStorage.removeItem(PERMISSIONS_CACHE_KEY)
  } catch {
    // Silently fail
  }
}

export const useGetPermissions = (
  accessToken: string | null
) =>
  useQuery<PermissionData, AxiosError<ApiError>>({
    queryKey: ["rolesAndBrokersData", accessToken],
    queryFn: async () => {
      const data = await getPermissions()
      savePermissionsToCache(data)
      return data
    },
    initialData: getPermissionsFromCache,
    placeholderData: keepPreviousData,
    enabled: !!accessToken,
    retry: 1,
    staleTime: 12 * 60 * 60 * 1000,
  })
